import { Component, OnInit, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { MeetingService } from '../../../common/meeting.service';

@Component({
  selector: 'app-purchase-order-manual-entry-form',
  templateUrl: './purchase-order-manual-entry-form.component.html',
  styleUrls: ['./purchase-order-manual-entry-form.component.css', '../../../app.component.css'],
  providers : [MeetingService]
})

export class PurchaseOrderManualEntryFormComponent implements OnInit {

 public meetingId = 0;
 public meeting : any = {
  distributorId : 0,
  supplierId : 0,
  type : 'Supplier',
  orderPlaced : 1,
  orderAmount : '',
  orderId : '',
  realMeeting : 3,
  eventId : 0,
  distributorTeamId : 0,
  supplierTeamId : 0,
  attendanceStatus : 1
 }
 public supplier : any = {
  id : '',
  companyName : ''
 }
 public distributor : any = {
  id : '',
  companyName : ''
 }
 public spinner: boolean = false;

 constructor(private snackBar: MdSnackBar, private meetingService: MeetingService){
 }

 ngOnInit(){
 }

 save(){
  this.spinner = true;
  this.meetingService.save({meeting: this.meeting}).subscribe(
   response => {
    this.spinner = false;
    this.snackBar.open("Meeting "+(this.meetingId ? 'updated' : 'created')+" successfully",'',{duration:4000});
    this.onSave.emit();
   },
   error => {
    this.spinner = false;
    this.snackBar.open(error,'',{duration:4000});
   }
  );
 }

 onSave = new EventEmitter();

 formValid(meetingForm){
  var flag = true;
  if(flag && !meetingForm.valid)
  flag = false;
  if(!flag)
  this.snackBar.open('Please fill all mandatory fields!','',{duration:4000});
  return flag;
 }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/purchase-orders/purchase-order-manual-entry-form/purchase-order-manual-entry-form.component.ts